export const PERMISSIONS = {
  PRODUCTS_VIEW: 'products.view',
  PRODUCTS_ADD: 'products.add',
  PRODUCTS_EDIT: 'products.edit',
  PRODUCTS_DELETE: 'products.delete',
  PRODUCTS_ANY: 'products.any',

  ORDERS_VIEW: 'orders.view',
  ORDERS_EDIT: 'orders.edit',
  ORDERS_ANY: 'orders.any',

  COUPONS_VIEW: 'coupons.view',
  COUPONS_CREATE: 'coupons.create',
  COUPONS_ANY: 'coupons.any',

  CUSTOMERS_VIEW: 'customers.view',
  CUSTOMERS_ANY: 'customers.any',

  REVIEWS_VIEW: 'reviews.view',
  REVIEWS_ANY: 'reviews.any',

  USERS_VIEW: 'users.view',
  USERS_ADD: 'users.add',
  USERS_ANY: 'users.any',

  SHIPPING_ANY: 'shipping.any',

  PAGES_VIEW: 'pages.view',
  PAGES_ANY: 'pages.any',

  SETTINGS_PAYMENT_METHODS: 'settings.editPaymentMethods',
  SETTINGS_DOMAIN: 'settings.editDomain',
  SETTINGS_SEO: 'settings.editSeo',
  SETTINGS_NOTIFICATIONS: 'settings.editNotifications',

  INFO_EDIT: 'info.edit',

  COMPLAINTS_EDIT: 'complaints.edit',
  CONTACTS_EDIT: 'contacts.edit',
  NEWSLETTER_EDIT: 'newsletter.edit',
  WALLET_ANY: 'all',

  TRANSACTIONS_VIEW: 'transactions.view',
  TRANSACTIONS_ANY: 'transactions.any',

  EXPORT_ANY: 'export.any',
  EXPORT_VIEW: 'export.view',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

/**
 * Check if a user has a specific permission.
 * Permissions come from the API as a string array, e.g. ['*'], ['products.*', 'orders.view']
 */
export function hasPermission(
  userPermissions: string[] | null | undefined,
  required: string
): boolean {
  if (!userPermissions || userPermissions.length === 0) return false;

  return userPermissions.some((perm) => {
    // Wildcard - full access
    if (perm === '*') return true;

    // Exact match
    if (perm === required) return true;

    // Category wildcard, e.g. 'products.*' matches 'products.view'
    if (perm.endsWith('.*')) {
      const prefix = perm.slice(0, -2);
      return required.startsWith(prefix + '.') || required === prefix;
    }

    return false;
  });
}
